import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

function setupEmblaSlider(root) {
    const viewport = root.querySelector('.embla__viewport');
    if (!viewport) {
        return;
    }

    const prevBtn = root.querySelector('.embla__button--prev');
    const nextBtn = root.querySelector('.embla__button--next');
    const dotsRoot = root.querySelector('.embla__dots');

    const slideCount = root.querySelectorAll('.embla__slide').length;
    if (!slideCount) {
        return;
    }

    if (slideCount <= 1) {
        if (dotsRoot) {
            dotsRoot.hidden = true;
        }
        if (prevBtn) {
            prevBtn.hidden = true;
        }
        if (nextBtn) {
            nextBtn.hidden = true;
        }
    }
    const loopEnabled = slideCount > 1;
    const plugins =
        slideCount > 1
            ? [
                  Autoplay({
                      delay: 4000,
                      stopOnInteraction: false,
                      stopOnMouseEnter: false,
                      stopOnFocusIn: false,
                  }),
              ]
            : [];

    const emblaApi = EmblaCarousel(
        viewport,
        {
            loop: loopEnabled,
            align: 'start',
            containScroll: loopEnabled ? false : 'trimSnaps',
            duration: 50,
        },
        plugins
    );

    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    if (prevBtn) {
        prevBtn.addEventListener('click', scrollPrev);
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', scrollNext);
    }

    const renderDots = () => {
        if (!dotsRoot) {
            return;
        }
        dotsRoot.innerHTML = '';
        emblaApi.scrollSnapList().forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'embla__dot';
            dot.setAttribute('aria-label', `Slide ${index + 1}`);
            dot.addEventListener('click', () => emblaApi.scrollTo(index));
            dotsRoot.appendChild(dot);
        });
        syncDots();
    };

    const syncDots = () => {
        if (!dotsRoot) {
            return;
        }
        const selected = emblaApi.selectedScrollSnap();
        Array.prototype.forEach.call(dotsRoot.children, (dot, i) => {
            dot.classList.toggle('is-selected', i === selected);
        });
    };

    const toggleNavDisabled = () => {
        if (loopEnabled) {
            if (prevBtn) {
                prevBtn.removeAttribute('disabled');
            }
            if (nextBtn) {
                nextBtn.removeAttribute('disabled');
            }
            return;
        }
        if (prevBtn) {
            prevBtn.toggleAttribute('disabled', !emblaApi.canScrollPrev());
        }
        if (nextBtn) {
            nextBtn.toggleAttribute('disabled', !emblaApi.canScrollNext());
        }
    };

    const onSelect = () => {
        syncDots();
        toggleNavDisabled();
    };

    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', () => {
        renderDots();
        onSelect();
    });

    // Recalculate snaps after lazy images settle (avoids height/scroll jumps).
    const images = root.querySelectorAll('img');
    let pending = 0;
    const maybeReInit = () => {
        pending -= 1;
        if (pending <= 0) {
            emblaApi.reInit();
        }
    };
    Array.prototype.forEach.call(images, (img) => {
        if (img.complete) {
            return;
        }
        pending += 1;
        img.addEventListener('load', maybeReInit, { once: true });
        img.addEventListener('error', maybeReInit, { once: true });
    });

    renderDots();
    onSelect();
}

function setupEmblaThumbsNav(root) {
    const viewport = root.querySelector('.embla__viewport');
    if (!viewport) {
        return;
    }

    const slideCount = viewport.querySelectorAll('.embla__slide').length;
    if (!slideCount) {
        return;
    }

    const thumbsRoot = root.querySelector('.embla__thumbs');
    const thumbButtons = thumbsRoot ? thumbsRoot.querySelectorAll('.embla__thumb') : [];

    const loopEnabled = slideCount > 1;
    const plugins = loopEnabled
        ? [
              Autoplay({
                  delay: 5000,
                  stopOnInteraction: false,
                  stopOnMouseEnter: true,
                  stopOnFocusIn: true,
              }),
          ]
        : [];

    const emblaApi = EmblaCarousel(
        viewport,
        {
            loop: loopEnabled,
            align: 'start',
            containScroll: loopEnabled ? false : 'trimSnaps',
        },
        plugins
    );

    const syncThumbs = () => {
        const selected = emblaApi.selectedScrollSnap();
        Array.prototype.forEach.call(thumbButtons, (btn, i) => {
            const on = i === selected;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
    };

    Array.prototype.forEach.call(thumbButtons, (btn, i) => {
        btn.addEventListener('click', () => emblaApi.scrollTo(i));
    });

    emblaApi.on('select', syncThumbs);
    emblaApi.on('reInit', syncThumbs);
    syncThumbs();
}

document.querySelectorAll('.embla.block-slider').forEach(setupEmblaSlider);
document.querySelectorAll('.embla.embla--thumbs-nav').forEach(setupEmblaThumbsNav);
